import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppFooter } from '../components/app-footer/app-footer';
import { LanguageSelector } from '../components/language-selector/language-selector';

@Component({
  selector: 'app-footer-only-layout',
  standalone: true,
  imports: [RouterOutlet, AppFooter, LanguageSelector],
  templateUrl: './footer-only-layout.html',
  styleUrl: './footer-only-layout.css',
})
export class FooterOnlyLayout {}
